import { type Customer } from '@hungryroot/customer';
import { MealTypes } from '@hungryroot/icons';
import {
  FoodProfileDisclosure,
  TagPreference,
} from '@hungryroot/page-food-profile';
import { Switch } from '@hungryroot/pho';
import { Paragraph } from '@hungryroot/ramen';
import { type PreferenceOption } from '@hungryroot/rest/api/v2/preference_options/get/get_preference_options';

import { useFoodProfilePage } from '../../utils/useFoodProfilePage';
import styles from './FoodFormatSection.module.css';

const getSwitchIcon = (tag: PreferenceOption) => {
  if (tag.image_url) return <img alt={tag.name} src={tag.image_url} />;
  if (tag.thumbnail_url) return <img alt={tag.name} src={tag.thumbnail_url} />;
};

interface Props {
  testid?: string;
  customerId: Customer['id'];
}

export function FoodFormatSection(props: Props) {
  const { testid, customerId } = props;

  const { subtitle, preferencesAndTags, onSwitchSelect } = useFoodProfilePage({
    customerId,
    page: 'preference_options.food_format',
  });

  return (
    <section data-testid={testid} className={styles.container}>
      <FoodProfileDisclosure
        testid={`${testid}-disclosure`}
        title="Meal types"
        subtitle={subtitle || 'Set your preferences.'}
        icon={<MealTypes />}
        deepLink="food-formats"
      >
        <Paragraph className={styles.text}>
          We’ll use your preferences to suggest meal types that suit your
          tastes.
        </Paragraph>
        <div className={styles['switch-layout']}>
          {preferencesAndTags?.map(([preference, tag]) => {
            return (
              <Switch
                key={tag.tag_id}
                testid={`${testid}-${tag.tag_id}`}
                label={tag.name}
                enabled={preference === TagPreference.Selected}
                onChange={() => {
                  onSwitchSelect(tag, !preference);
                }}
                icon={getSwitchIcon(tag)}
              />
            );
          })}
        </div>
      </FoodProfileDisclosure>
    </section>
  );
}
